import { render, staticRenderFns } from "./GoodslistBody.vue?vue&type=template&id=fc1a94a8&scoped=true"
import script from "./GoodslistBody.vue?vue&type=script&lang=js"
export * from "./GoodslistBody.vue?vue&type=script&lang=js"
import style0 from "./GoodslistBody.vue?vue&type=style&index=0&id=fc1a94a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1a94a8",
  null
  
)

export default component.exports